import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import LegacyButton from "legacy/LegacyButton"
import {
  buildRoute,
  centsToDollars,
  humanize,
  isListedPumpPrice,
  metaFuel,
  orderedAvailableCategories,
  parseJSONError,
} from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import _ from "lodash"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class ReservationChargeItemModal extends ApplicationComponent {
  constructor(args) {
    super(args)

    const chargeItemState = this.getStateFromChargeItem(this.props.selectedItem)
    const lastMeterReading = this.props.lastMeterReading
    const contextualStartDate = !this.props.contract
      ? $context.reservation.startDate
      : this.props.startDate
    const contextualEndDate = !this.props.contract
      ? $context.reservation.endDate
      : this.props.endDate
    const frequency = chargeItemState.frequency || this.props.frequencies[0]
    const serviceDateType = "date"
    const { startDate, endDate } = this.defaultDateSetForInitialization({
      frequency,
      serviceDateType,
      contextualStartDate,
      contextualEndDate,
    })

    this.state = {
      showModal: false,
      processing: false,
      price: "",
      taxRate: "",
      quantity: "",
      billing: "add_to_next_bill",
      duration: "whole_reservation",
      validationMessage: "",
      frequency,
      serviceDateType,
      lastMeterReading,
      contextualStartDate,
      contextualEndDate,
      startDate,
      endDate,
      selectedMeterId:
        this.props.currentMeter && this.props.currentMeter.id.toString(),
      ...chargeItemState,
    }
    this.durations = ["whole_reservation", "specific_dates"]
    this.serviceDateTypes = ["date", "date_range"]
    this.validator = validatorFactory({ autoForceUpdate: this })
    this.handleFrequencyChange = this.handleFrequencyChange.bind(this)
    this.handleServiceDateTypeChange =
      this.handleServiceDateTypeChange.bind(this)
    this.handleDurationChange = this.handleDurationChange.bind(this)
    this.handlePosItemChange = this.handlePosItemChange.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSelectDate = this.handleSelectDate.bind(this)
    this.handleOpenModal = this.handleOpenModal.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.handleStopFuturePayments = this.handleStopFuturePayments.bind(this)
    this.finish = this.finish.bind(this)
    this.createCharge = this.createCharge.bind(this)
    this.updateCharge = this.updateCharge.bind(this)
    this.deleteCharge = this.deleteCharge.bind(this)
  }

  componentDidUpdate(prev, prevState) {
    // Adding the ability to open the modal without the button.
    // It's a little tricky because this component has a button attached to it.
    // The alternative is breaking the "modal" out of this component into a standalone
    // and then turn this component into essentially just a container that renders the button
    if (
      this.props.showEditModal != null &&
      prev.showEditModal !== this.props.showEditModal
    ) {
      this.setState({
        showModal: this.props.showEditModal,
        ...this.getStateFromChargeItem(this.props.selectedItem),
      })
    }
    if (
      this.props.currentMeter &&
      this.state.selectedMeterId !== prevState.selectedMeterId
    ) {
      if (
        this.state.selectedMeterId !== this.props.currentMeter.id.toString()
      ) {
        this.setState({
          lastMeterReading: "",
        })
      } else {
        this.setState({
          lastMeterReading: this.props.lastMeterReading,
        })
      }
    }
  }

  handleOpenModal() {
    this.setState({ showModal: true })
  }

  handleCloseModal() {
    if (this.props.showEditModal && this.props.closeCallback) {
      this.props.closeCallback()
      this.setState({ showModal: false })
    } else {
      this.setState({ showModal: false })
    }
  }

  handleFrequencyChange(event) {
    const frequency = event.target.value
    if (frequency === "one_time") {
      const { startDate, endDate } = this.defaultDateSetForOneTimeFrequency()
      this.setState({
        frequency,
        billing: "add_to_next_bill",
        duration: "",
        startDate,
        endDate,
      })
    } else {
      this.setState({
        frequency,
        billing: "first_of_month",
        duration: "whole_reservation",
        startDate: moment(this.state.contextualStartDate),
        endDate: moment(this.state.contextualEndDate),
      })
    }
  }

  defaultDateSetForInitialization({
    frequency,
    serviceDateType,
    contextualStartDate,
    contextualEndDate,
  }) {
    if (this.isMonthly(frequency)) {
      return {
        startDate: moment(contextualStartDate),
        endDate: moment(contextualEndDate),
      }
    }

    if (this.isOneTime(frequency)) {
      return this.defaultDateSetForOneTimeFrequency({
        serviceDateType,
        contextualStartDate,
        contextualEndDate,
      })
    }
  }

  defaultDateSetForOneTimeFrequency({
    serviceDateType = this.state.serviceDateType,
    contextualStartDate = this.state.contextualStartDate,
    contextualEndDate = this.state.contextualEndDate,
  } = {}) {
    const today = moment()
    const _contextualStartDate = moment(contextualStartDate)
    const _contextualEndDate = moment(contextualEndDate)

    const dateRangeSelected = serviceDateType === "date_range"

    const startDate = (() => {
      if (dateRangeSelected) return _contextualStartDate
      if (today < _contextualStartDate) return _contextualStartDate
      if (today >= _contextualStartDate && today <= _contextualEndDate)
        return today
      if (today > _contextualEndDate) return _contextualEndDate
    })()

    const endDate = dateRangeSelected ? _contextualEndDate : null

    return { startDate, endDate }
  }

  handleSelectDate(dateState) {
    if (dateState.startDate) {
      if (
        this.state.endDate &&
        dateState.startDate.isAfter(this.state.endDate)
      ) {
        dateState.endDate = null
      }
    }
    if (dateState.endDate) {
      if (
        this.state.startDate &&
        dateState.endDate.isBefore(this.state.startDate)
      ) {
        dateState.startDate = null
      }
    }
    this.setState(dateState)
  }

  handleDurationChange(event) {
    this.setState({
      duration: event.target.value,
      startDate: moment(this.state.contextualStartDate),
      endDate: moment(this.state.contextualEndDate),
    })
  }

  handleServiceDateTypeChange(event) {
    const serviceDateType = event.target.value
    const { startDate, endDate } = this.defaultDateSetForOneTimeFrequency({
      serviceDateType,
    })

    this.setState({
      serviceDateType,
      startDate,
      endDate,
    })
  }

  handlePosItemChange(event) {
    const chargeItem = _.find(this.props.chargeItems, {
      id: Number(event.target.value),
    })
    this.setState(this.getStateFromChargeItem(chargeItem))
  }

  handleStopFuturePayments() {
    this.setState({
      endDate: moment.max(
        moment.min(
          moment().endOf("month"),
          moment($context.reservation.endDate)
        ),
        this.state.startDate
      ),
      duration: "specific_dates",
    })
  }

  getStateFromChargeItem(chargeItem) {
    if (chargeItem && (chargeItem.start_date || chargeItem.end_date)) {
      chargeItem.startDate = chargeItem.start_date
      chargeItem.endDate = chargeItem.end_date
    }

    if (!chargeItem) {
      return {}
    }

    const state = {
      selectedItem: chargeItem,
      price: chargeItem.unitPrice,
      taxRate: chargeItem.taxRate,
      quantity: chargeItem.quantity,
      frequency:
        chargeItem.frequency && chargeItem.category !== "metered_electric"
          ? chargeItem.frequency
          : null,
      billing: chargeItem.billing || null,
      duration:
        chargeItem.startDate || chargeItem.endDate ? "specific_dates" : null,
      startDate: chargeItem.startDate ? moment(chargeItem.startDate) : null,
      endDate: chargeItem.endDate ? moment(chargeItem.endDate) : null,
    }

    return _.omitBy(state, (val) => _.isNil(val))
  }

  datepickerDisplayValueForStart() {
    if (this.isStartOfReservation() && this.isMonthly()) {
      return "Reservation Start"
    }
  }

  datepickerDisplayValueForEnd() {
    if (this.isEndOfReservation() && this.isMonthly()) {
      return "Reservation End"
    }
  }

  orderedCategories() {
    const enabledCategories = orderedAvailableCategories(
      this.props.chargeItems,
      $context.orderedCategories
    )
    // put a 'Listed Pump Price' section at the top of the list, even though it's not a real category
    enabledCategories.unshift("listed_pump_prices")
    return _.filter(enabledCategories, (category) => {
      const items = this.itemsGroupedByCategory()[category]
      return items && items.length > 0
    })
  }

  itemsGroupedByCategory() {
    const groupedItems = {}
    this.props.chargeItems.forEach((item) => {
      if (isListedPumpPrice(item)) {
        const itemsInCategory = groupedItems.listed_pump_prices || []
        itemsInCategory.push(item)
        groupedItems.listed_pump_prices = itemsInCategory
      } else {
        const itemsInCategory = groupedItems[item.category] || []
        itemsInCategory.push(item)
        groupedItems[item.category] = itemsInCategory
      }
    })
    return groupedItems
  }

  availableBillings() {
    return this.state.frequency === "one_time"
      ? this.props.billings.oneTime
      : this.props.billings.monthly
  }

  isMeteredElectric() {
    return (
      this.state.selectedItem &&
      this.state.selectedItem.category === "metered_electric"
    )
  }

  isEditMode() {
    return this.props.editMode
  }

  isMonthly(frequency = this.state.frequency) {
    return ["monthly_full", "monthly_pro_rated"].includes(frequency)
  }

  isOneTime(frequency = this.state.frequency) {
    return frequency === "one_time"
  }

  isStartOfReservation() {
    return (
      this.state.startDate &&
      this.state.startDate.isSame(this.state.contextualStartDate)
    )
  }

  isEndOfReservation() {
    return (
      this.state.endDate &&
      this.state.endDate.isSame(this.state.contextualEndDate)
    )
  }

  hasSettledPayments() {
    return this.props.selectedItem.lineItems.length > 0
  }

  pricePrecision() {
    return this.state.selectedItem && metaFuel(this.state.selectedItem.category)
      ? "4"
      : "2"
  }

  finish() {
    this.validator.showMessages()
    if (this.validator.allValid()) {
      if (this.props.saveCallback) {
        const callbackArguments = {
          id: this.state.selectedItem.id,
          unitPrice: this.state.price,
          taxRate: this.state.taxRate,
          quantity: this.state.quantity,
          frequency: this.state.frequency,
          billing: this.state.billing,
          name: this.state.selectedItem.name,
          category: this.state.selectedItem.category,
        }
        if (this.isMonthly() && !this.isStartOfReservation()) {
          callbackArguments.start_date =
            this.state.startDate.format("YYYY-MM-DD")
        }
        if (this.isMonthly() && !this.isEndOfReservation()) {
          callbackArguments.end_date = this.state.endDate.format("YYYY-MM-DD")
        }
        this.props.saveCallback(callbackArguments)
        this.handleCloseModal()
        return
      }
      if (this.isEditMode()) {
        this.updateCharge()
      } else {
        this.createCharge()
      }
    }
  }

  createCharge() {
    this.setState({ processing: true })

    const { startDate, endDate } = this.dateSetForChargeSubmit()
    const params = _.omitBy(
      {
        pos_item_id: this.state.selectedItem.id,
        unit_price: this.state.price,
        tax_rate: this.state.taxRate,
        quantity: this.state.quantity,
        frequency: this.state.frequency,
        billing: this.state.billing,
        start_date: startDate,
        end_date: endDate,
      },
      (val) => _.isNil(val)
    )

    if (this.isMeteredElectric()) {
      params.meter_id = this.state.selectedMeterId
      params.last_meter_reading = this.state.lastMeterReading
      params.current_meter_reading = this.state.currentMeterReading
    }
    $.post($context.createUrl, params, (data) => {
      window.history.replaceState(null, document.title, "#charges")
      window.location.reload(false)
    }).fail((data) => {
      this.setState({
        validationMessage:
          parseJSONError(data.responseText) ||
          "There was an error processing your request.",
        processing: false,
      })
    })
  }

  updateCharge() {
    this.setState({ processing: true })

    const { startDate, endDate } = this.dateSetForChargeSubmit()
    const params = _.omitBy(
      {
        pos_item_id: this.state.selectedItem.id,
        start_date: startDate,
        end_date: endDate,
      },
      (val) => _.isNil(val)
    )

    $.patch(
      buildRoute($context.updateUrl, {
        chargeItemId: this.state.selectedItem.id,
      }),
      params,
      (data) => {
        window.history.replaceState(null, document.title, "#charges")
        window.location.reload(false)
      }
    ).fail((data) => {
      this.setState({
        validationMessage:
          parseJSONError(data.responseText) ||
          "There was an error processing your request.",
        processing: false,
      })
    })
  }

  dateSetForChargeSubmit() {
    let startDate = this.state.startDate
      ? this.state.startDate.format("YYYY-MM-DD")
      : null
    let endDate = this.state.endDate
      ? this.state.endDate.format("YYYY-MM-DD")
      : null

    if (this.isMonthly() && this.isStartOfReservation()) {
      startDate = null
    }
    if (this.isMonthly() && this.isEndOfReservation()) {
      endDate = null
    }

    return { startDate, endDate }
  }

  deleteCharge() {
    if (
      confirm(
        `Are you sure you want to ${
          this.hasSettledPayments() ? "refund all payments and " : ""
        }delete this charge?`
      )
    ) {
      this.setState({ processingDelete: true })
      $.delete(
        buildRoute($context.updateUrl, {
          chargeItemId: this.state.selectedItem.id,
        }),
        (data) => {
          window.location.reload(false)
        }
      )
    }
  }

  renderLaunchButton() {
    if (this.isEditMode()) {
      return (
        <LegacyButton
          type="ghost"
          className="hidden-print"
          onClick={this.handleOpenModal}
        >
          Edit
        </LegacyButton>
      )
    } else {
      return (
        <LegacyButton
          type="primary"
          className="hidden-print"
          onClick={this.handleOpenModal}
        >
          Add Charge
        </LegacyButton>
      )
    }
  }

  renderFieldsForItemCategory() {
    if (this.isMeteredElectric()) {
      return this.renderMeteredElectricFields()
    } else {
      return this.renderFormFields()
    }
  }

  renderMeteredElectricFields() {
    return (
      <div>
        {this.props.meters && this.props.meters.length > 0 && (
          <div className="col-xs-12">
            <FormGroup
              inputType="select"
              label="Meter"
              labelIcon="icon icon-md-info cursor-pointer ml-2 -mt-1 font-semibold"
              labelIconTooltip="The default meter is based on the meter this reservation was last billed for. If there are no previous meter reads, we default to the meter associated to this reservation's assigned space"
              name="selectedMeterId"
              onChange={this.handleInputChange}
              value={this.state.selectedMeterId}
              disabled={this.isEditMode()}
            >
              <option value="">None</option>
              {_.map(this.props.meters, (meter) => (
                <option value={meter.id} key={meter.id}>
                  {humanize(meter.name)} (Space: {meter.spaceName})
                </option>
              ))}
            </FormGroup>
          </div>
        )}
        <div className="col-xs-4">
          <FormGroup
            inputType="currency"
            label="Unit Price"
            name="price"
            value={this.state.price}
            onChange={this.handleInputChange}
            disabled={this.isEditMode()}
            validation={this.validator.message(
              "price",
              this.state.price,
              `required|maxDecimalPrecision:${this.pricePrecision()}`
            )}
          />
        </div>
        <div className="col-xs-4">
          <FormGroup
            inputType="percentage"
            label="Tax"
            name="taxRate"
            value={this.state.taxRate}
            onChange={this.handleInputChange}
            disabled={this.isEditMode()}
          />
        </div>
        <div className="col-xs-4">
          <FormGroup
            inputType="select"
            label="Billing"
            name="billing"
            value={this.state.billing}
            onChange={this.handleInputChange}
            disabled={
              this.availableBillings().length === 1 || this.isEditMode()
            }
            validation={this.validator.message(
              "billing",
              this.state.billing,
              "required"
            )}
          >
            {_.map(this.availableBillings(), (billing) => (
              <option key={billing} value={billing}>
                {humanize(billing)}
              </option>
            ))}
          </FormGroup>
        </div>
        <div className="col-xs-6">
          <FormGroup
            label="Last Meter Reading"
            name="lastMeterReading"
            value={this.state.lastMeterReading}
            onChange={this.handleInputChange}
            validation={this.validator.message(
              "last_meter_reading",
              this.state.lastMeterReading,
              "required|numeric"
            )}
            disabled={this.isEditMode()}
          />
        </div>
        <div className="col-xs-6">
          <FormGroup
            label="Current Meter Reading"
            name="currentMeterReading"
            value={this.state.currentMeterReading}
            onChange={this.handleInputChange}
            validation={this.validator.message(
              "current_meter_reading",
              this.state.currentMeterReading,
              "required|numeric"
            )}
            disabled={this.isEditMode()}
          />
        </div>
      </div>
    )
  }

  renderFormFields() {
    return (
      <div>
        <div className="col-xs-4">
          <FormGroup
            inputType="currency"
            label="Unit Price"
            name="price"
            value={this.state.price}
            onChange={this.handleInputChange}
            disabled={this.isEditMode()}
            validation={this.validator.message(
              "price",
              this.state.price,
              `required|numeric|min:0,num|maxDecimalPrecision:${this.pricePrecision()}`
            )}
          />
        </div>
        <div className="col-xs-4">
          <FormGroup
            label="Quantity"
            name="quantity"
            value={this.state.quantity}
            onChange={this.handleInputChange}
            validation={this.validator.message(
              "quantity",
              this.state.quantity,
              "required|numeric"
            )}
            disabled={this.isEditMode()}
          />
        </div>
        <div className="col-xs-4">
          <FormGroup
            inputType="percentage"
            label="Tax"
            name="taxRate"
            value={this.state.taxRate}
            onChange={this.handleInputChange}
            disabled={this.isEditMode()}
          />
        </div>
        <div className="col-xs-6">
          <FormGroup
            inputType="select"
            label="Frequency"
            name="frequency"
            value={this.state.frequency}
            onChange={this.handleFrequencyChange}
            validation={this.validator.message(
              "frequency",
              this.state.frequency,
              "required"
            )}
            disabled={this.isEditMode()}
          >
            {_.map(this.props.frequencies, (frequency) => (
              <option key={frequency} value={frequency}>
                {humanize(frequency)}
              </option>
            ))}
          </FormGroup>
        </div>
        <div className="col-xs-6">
          <FormGroup
            inputType="select"
            label="Billing"
            name="billing"
            value={this.state.billing}
            onChange={this.handleInputChange}
            disabled={
              this.availableBillings().length === 1 || this.isEditMode()
            }
            validation={this.validator.message(
              "billing",
              this.state.billing,
              "required"
            )}
          >
            {_.map(this.availableBillings(), (billing) => (
              <option key={billing} value={billing}>
                {humanize(billing)}
              </option>
            ))}
          </FormGroup>
        </div>
      </div>
    )
  }

  renderDateSection() {
    const isWholeReservation = this.state.duration === "whole_reservation"
    return (
      <div>
        <div className="col-xs-4">
          <FormGroup
            inputType="select"
            label="Duration"
            name="duration"
            value={this.state.duration}
            onChange={this.handleDurationChange}
          >
            {_.map(this.durations, (duration) => (
              <option key={duration} value={duration}>
                {humanize(duration)}
              </option>
            ))}
          </FormGroup>
        </div>
        <div className="col-xs-4">
          <FormGroup
            inputType="datepicker"
            name="startDate"
            label="Start Date"
            value={this.state.startDate ? this.state.startDate.format("L") : ""}
            startDate={moment(this.state.contextualStartDate).format("L")}
            endDate={moment(this.state.contextualEndDate).format("L")}
            onChange={(date) =>
              this.handleSelectDate({ startDate: moment(date, "L") })
            }
            disabled={isWholeReservation}
            validation={this.validator.message(
              "start_date",
              this.state.startDate,
              "required"
            )}
            displayValue={this.datepickerDisplayValueForStart()}
          />
        </div>
        <div className="col-xs-4">
          <FormGroup
            inputType="datepicker"
            name="endDate"
            label="End Date"
            value={this.state.endDate ? this.state.endDate.format("L") : ""}
            startDate={
              this.state.startDate
                ? this.state.startDate.format("L")
                : moment(this.state.contextualStartDate).format("L")
            }
            endDate={moment(this.state.contextualEndDate).format("L")}
            onChange={(date) =>
              this.handleSelectDate({ endDate: moment(date, "L") })
            }
            disabled={isWholeReservation}
            displayValue={this.datepickerDisplayValueForEnd()}
          />
        </div>
      </div>
    )
  }

  renderServiceDateSection() {
    const renderOneDate = this.state.serviceDateType === "date"
    const renderDateRange = !renderOneDate

    const columnSize = renderOneDate ? "6" : "4"

    const StartDate = () => {
      const label = renderOneDate ? "Service Date" : "Start Date"

      return (
        <div className={`col-xs-${columnSize}`}>
          <FormGroup
            inputType="datepicker"
            name="startDate"
            label={label}
            value={this.state.startDate ? this.state.startDate.format("L") : ""}
            onChange={(date) =>
              this.handleSelectDate({ startDate: moment(date, "L") })
            }
            validation={this.validator.message(
              "start_date",
              this.state.startDate,
              "required"
            )}
            displayValue={this.datepickerDisplayValueForStart()}
          />
        </div>
      )
    }

    const EndDate = () => {
      return (
        <div className="col-xs-4">
          <FormGroup
            inputType="datepicker"
            name="endDate"
            label="End Date"
            value={this.state.endDate ? this.state.endDate.format("L") : ""}
            onChange={(date) =>
              this.handleSelectDate({ endDate: moment(date, "L") })
            }
            validation={this.validator.message(
              "end_date",
              this.state.endDate,
              "required"
            )}
            displayValue={this.datepickerDisplayValueForEnd()}
          />
        </div>
      )
    }

    return (
      <div>
        <div className={`col-xs-${columnSize}`}>
          <FormGroup
            inputType="select"
            label="Service Date Type"
            name="serviceDateType"
            value={this.state.serviceDateType}
            onChange={this.handleServiceDateTypeChange}
          >
            {_.map(this.serviceDateTypes, (serviceDateType) => (
              <option key={serviceDateType} value={serviceDateType}>
                {humanize(serviceDateType)}
              </option>
            ))}
          </FormGroup>
        </div>
        <StartDate />
        {renderDateRange && <EndDate />}
      </div>
    )
  }

  renderPaymentTable() {
    if (!this.hasSettledPayments()) return null

    const sortedLineItems = _.orderBy(
      this.props.selectedItem.lineItems,
      [
        (lineItem) => {
          return moment(lineItem.dueAt)
        },
      ],
      ["asc"]
    )

    return (
      <div className="mt-8">
        <h4 className="font-bold">Settled Payments</h4>
        <hr className="mb-0 mt-4" />
        <table className="w-full table-auto">
          <tbody className="divide-y">
            {_.map(sortedLineItems, (lineItem) => (
              <tr key={lineItem.encodedId}>
                <td className="shrink px-4 py-2">
                  <i className="icon icon-circle-check text-teal-700" />
                </td>
                <td className="py-2 pr-4">{lineItem.dueAt}</td>
                <td className="px-4 py-2 text-right">
                  {centsToDollars(lineItem.totalAmount)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }

  render() {
    this.validator.purgeFields()
    const modalTitle =
      this.isEditMode() || this.props.showEditModal
        ? "Edit Charge"
        : "Add Charge"

    const buttonText =
      this.isEditMode() || this.props.showEditModal
        ? "Save Changes"
        : "Add Charge"

    return (
      <div>
        {this.renderLaunchButton()}
        <Modal
          isOpen={this.state.showModal}
          onClose={this.handleCloseModal}
          size="mediumFixed"
        >
          <Modal.Header title={modalTitle} />
          <Modal.Body>
            <p className="mb-6">
              Visit{" "}
              <a
                href={$context.editManageSalesUrl}
                target="_blank"
                rel="noreferrer"
                className="text-link"
              >
                Edit Items
              </a>{" "}
              to create a new item in your inventory
            </p>
            <div className="flex flex-col">
              <div className="col-xs-12">
                <FormGroup
                  inputType="select"
                  label="Item"
                  name="selectedItem"
                  onChange={this.handlePosItemChange}
                  value={
                    this.state.selectedItem
                      ? this.state.selectedItem.id
                      : "not_selected"
                  }
                  validation={this.validator.message(
                    "item",
                    this.state.selectedItem,
                    "required"
                  )}
                  disabled={this.isEditMode()}
                >
                  <option value="not_selected" disabled={true}>
                    (select an item)
                  </option>
                  {_.map(this.orderedCategories(), (category) => (
                    <optgroup label={humanize(category)} key={_.uniqueId()}>
                      {_.map(
                        this.itemsGroupedByCategory()[category],
                        (item) => (
                          <option value={item.id} key={item.id}>
                            {humanize(item.name)}
                          </option>
                        )
                      )}
                    </optgroup>
                  ))}
                </FormGroup>
              </div>
              {this.renderFieldsForItemCategory()}
              {this.isMonthly() && this.renderDateSection()}
              {this.isOneTime() && this.renderServiceDateSection()}
            </div>
            {this.validator.messageWhenPresent(this.state.validationMessage, {
              className: "bs-mb-3 text-danger text-bold",
            })}
            {this.isEditMode() && this.renderPaymentTable()}
          </Modal.Body>
          <Modal.Footer>
            <div className="flex w-full justify-end space-x-2">
              {this.isEditMode() && this.hasSettledPayments() && (
                <LegacyButton
                  className="btn btn-danger"
                  onClick={this.handleStopFuturePayments}
                >
                  Stop Future Payments
                </LegacyButton>
              )}
              {this.isEditMode() && (
                <LegacyButton
                  type={this.hasSettledPayments() ? "gray" : "red"}
                  onClick={this.deleteCharge}
                  processing={this.state.processingDelete}
                  processingText={
                    this.hasSettledPayments() ? "Refunding..." : "Deleting..."
                  }
                >
                  {this.hasSettledPayments() ? "Refund All" : "Delete"}
                </LegacyButton>
              )}
              <LegacyButton
                type="primary"
                processing={this.state.processing}
                onClick={this.finish}
                processingText="Saving..."
              >
                {buttonText}
              </LegacyButton>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

ReservationChargeItemModal.propTypes = {
  selectedItem: PropTypes.object,
  editMode: PropTypes.bool,
  showEditModal: PropTypes.bool,
  closeCallback: PropTypes.func,
  saveCallback: PropTypes.func,
  chargeItems: PropTypes.array.isRequired,
  frequencies: PropTypes.array.isRequired,
  billings: PropTypes.shape({
    oneTime: PropTypes.array.isRequired,
    monthly: PropTypes.array.isRequired,
  }).isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  contract: PropTypes.bool,
  lastMeterReading: PropTypes.string,
  currentMeter: PropTypes.object,
  meters: PropTypes.array,
}

export default ReservationChargeItemModal
